<template>
  <div class="listing" v-if="user">
    <section class="page">
      <header class="pageHeader">
        <div class="pageHeader__Inner">
          <h1 class="pageHeader__Title">Settings</h1>
        </div>
      </header>

      <div class="tab">
        <div class="tab__MenuWrapper">
          <nav class="tab__Menu">
            <ul class="tab__MenuList--Settings">
              <li>
                <router-link :to="{ name: 'Account' }">Your account</router-link>
              </li>
              <template v-if="isAdmin">
                <li>
                  <router-link :to="{ name: 'Organisation' }">Organisation</router-link>
                </li>
              </template>
            </ul>
          </nav>
        </div>

        <div class="tab__Wrapper">
          <router-view></router-view>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Settings',
  watch: {
    $route(to) {
      this.checkAdmin(to)
    },
  },
  computed: {
    user() {
      return this.$store.state.accounts.user
    },
    pending() {
      return this.$store.state.accounts.users.pending
    },
    isAdmin() {
      if (this.user.is_admin || this.user.is_org_admin) return true
      return false
    },
  },
  methods: {
    checkAdmin(path = this.$route.name) {
      if (!this.isAdmin && path !== 'Account') this.$router.push({ name: 'Account' })
    },
  },
  mounted() {
    this.checkAdmin()
  },
}
</script>
